type AnalyticsEventPayload = Record<string, unknown>;

interface AnalyticsConfig {
  workspaceId: string;
  environment: string;
  isEnabled: boolean;
}

class AnalyticsService {
  private workspaceId: string = 'unset';
  private environment: string = 'development';
  private enabled: boolean = true;

  initialize(config: AnalyticsConfig): void {
    this.workspaceId = config.workspaceId;
    this.environment = config.environment;
    this.enabled = config.isEnabled;
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }

  track(event: string, payload: AnalyticsEventPayload = {}): void {
    if (!this.enabled) {
      return;
    }
    try {
      const timestamp = new Date().toISOString();
      console.debug('[analytics]', {
        workspaceId: this.workspaceId,
        environment: this.environment,
        event,
        payload,
        timestamp
      });
    } catch (error) {
      console.error('[analytics] Failed to track event.', { error, event, payload });
    }
  }

  trackNavigation(path: string): void {
    this.track('navigation', { path });
  }

  trackError(error: unknown, context: AnalyticsEventPayload = {}): void {
    const details =
      error instanceof Error
        ? { name: error.name, message: error.message, stack: error.stack }
        : { value: String(error) };
    this.track('error', { ...context, ...details });
  }
}

export const analyticsService = new AnalyticsService();

